import note from './note';
import request from "./request";
import { isEmail, isEmpty } from './validate';
import loader from './loader';

const ajaxnonce = loschlegal.ajaxnonce;
const comment = document.getElementById('comment');

if( comment ) {
    comment.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(comment);
        const email = formData.get('email');
        const post_id = formData.get('post_id');

        if( !isEmail(email)) {
            note('Bitte geben Sie eine gültige E-Mail-Adresse ein.'); return;
        }

        if( isEmpty(post_id)){
            note('Bitte laden Sie die Seite neu und versuchen Sie es erneut.'); return;
        }

        const data = {
            action: `${loschlegal.theme_domain}_users_ajax_request`, // AJAX action
            ajaxnonce: ajaxnonce,
            callback: '_comment'
        }

        formData.forEach((value, key) => {
            data[key] = value;
        })

        comment.appendChild(loader())
        request(data)
    })
}